import * as moment from 'moment';
import * as d3 from 'd3';

// Finds the moving average
export function movingAvg(array, count, qualifier, propertyName) {
  // calculate average for subarray
  let avg = function(array, qualifier) {
    var sum = 0,
      count = 0,
      val;
    for (var i in array) {
      val = array[i];
      if (!qualifier || qualifier(val)) {
        sum += val;
        count++;
      }
    }
    return sum / count;
  };

  let result = [],
    val;

  // pad beginning of result with null values
  for (var i = 0; i < count - 1; i++) {
    let resultObject = {};
    resultObject[propertyName] = NaN;
    resultObject['id'] = i;
    result.push(resultObject);
  }

  // calculate average for each subarray and add to result
  for (var i = 0, len = array.length - count; i <= len; i++) {
    val = avg(array.slice(i, i + count), qualifier);
    let resultObject = {};
    if (isNaN(val)) {
      resultObject[propertyName] = NaN;
    } else {
      resultObject[propertyName] = val;
    }
    resultObject['id'] = i + (count - 1);
    result.push(resultObject);
  }

  return result;
}

// finds the moving average by subtracting today's total
// by the total from 7 days ago, and dividing it by 7
// does not work for days before 5/20
export function movingAvgSubtractMethod(array, count, propertyName) {
  let result = [],
    val;

  // pad beginning of result with null values
  // The reason why it's not starting on the 7th day was because it was skipping the 6th iteration so I made it so it gave the 7th day a zero, it's a very hacky day to do this
  for (var i = 0; i < count; i++) {
    let resultObject = {};
    resultObject['id'] = i;
    if (i == 6) {
      resultObject[propertyName] = 0;
      result.push(resultObject);
    } else {
      let resultObject = {};
      resultObject[propertyName] = NaN;
      result.push(resultObject);
    }
  }

  // calculate average for each subarray and add to result
  for (var i = 0, len = array.length - count; i <= len; i++) {
    val = (array[i + count] - array[i]) / 7;
    let resultObject = {};
    resultObject['id'] = i + count;
    if (isNaN(val)) {
      resultObject[propertyName] = NaN;
      result.push(resultObject);
    } else {
      resultObject[propertyName] = val;
      result.push(resultObject);
    }
  }

  return result;
}

// returns slope, intercept and r-square of the line
export function leastSquares(xSeries, ySeries) {
  var reduceSumFunc = function(prev, cur) {
    return prev + cur;
  };

  var xBar = (xSeries.reduce(reduceSumFunc) * 1.0) / xSeries.length;
  var yBar = (ySeries.reduce(reduceSumFunc) * 1.0) / ySeries.length;

  var ssXX = xSeries
    .map(function(d) {
      return Math.pow(d - xBar, 2);
    })
    .reduce(reduceSumFunc);

  var ssYY = ySeries
    .map(function(d) {
      return Math.pow(d - yBar, 2);
    })
    .reduce(reduceSumFunc);

  var ssXY = xSeries
    .map(function(d, i) {
      return (d - xBar) * (ySeries[i] - yBar);
    })
    .reduce(reduceSumFunc);

  var slope = ssXY / ssXX;
  var intercept = yBar - xBar * slope;
  var rSquare = Math.pow(ssXY, 2) / (ssXX * ssYY);

  return [slope, intercept, rSquare];
}

export function customDateFormat(d, i, interval) {
  let month = moment(d).format('MMM'),
    short_month = moment(d).format('MMMM'),
    day = moment(d).format('D');

  if (i % interval == 0 && short_month.length > 4) return `${month}. ${day}`;
  else if (i % interval == 0 && short_month.length <= 4)
    return `${short_month} ${day}`;
  else return '';
}

export function customMobileDateFormat(d, i) {
  let month = moment(d).format('MMM'),
    short_month = moment(d).format('MMMM'),
    day = moment(d).format('D');

  if (i % 6 == 0 && short_month.length > 4) return `${month}. ${day}`;
  else if (i % 6 == 0 && short_month.length <= 4)
    return `${short_month} ${day}`;
  else return '';
}

/// This function skips every fourth one instead of every sixth number on axis, used in new-tests.js
export function customMobileDateFormatFour(d, i) {
  let month = moment(d).format('MMM'),
    short_month = moment(d).format('MMMM'),
    day = moment(d).format('D');

  if (i % 4 == 0 && short_month.length > 4) return `${month}. ${day}`;
  else if (i % 4 == 0 && short_month.length <= 4)
    return `${short_month} ${day}`;
  else return '';
}

export function customNumFormat(d, i) {
  if (i != 0) {
    return d3.format(',')(d);
  }
}

export function customPercFormat(d, i) {
  if (i != 0) {
    return d3.format('.3')(d) + '%';
  }
}

export const mergeArrays = (a1, a2, key) =>
  a1.map(itm => ({
    ...a2.find(item => item[key] === itm[key] && item),
    ...itm,
  }));

// dates should be listed in this format: April 2017
export function getLabeledData(data, dates) {
  // always annotate the latest datapoint
  let labeledData = [data[data.length - 1]];
  dates.forEach(date => {
    date = moment(date, 'M_D');
    let foundData = data.find(d => d.date.isSame(date));
    if (foundData) {
      labeledData.push(foundData);
    }
  });
  return labeledData;
}
